
<template>
  <div>
    <h2
      id="customer-admin-pending-invitesheader"
      class="sr-only"
    >
      Pending Invites Form
    </h2>
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-condensed">
        <caption>List of Pending Invites</caption>
        <thead>
          <tr>
            <th width="20%">
              <a
                href="#"
                scope="col"
                aria-label="Click to sort by email"
                @click.prevent="resortBy('email')"
              >
                Email
              </a>
              <svg
                v-if="isSortAscending && sortField == 'email'"
                class="icon-chevron-up"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-chevron-up" />
              </svg>
              <svg
                v-if="!isSortAscending && sortField == 'email'"
                class="icon-chevron-down"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-chevron-down" />
              </svg>
            </th>
            <th width="20%">
              <a
                href="#"
                scope="col"
                aria-label="Click to sort by date"
                @click.prevent="resortBy('createdDate')"
              >
                First Sent
              </a>
              <svg
                v-if="isSortAscending && sortField == 'createdDate'"
                class="icon-chevron-up"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-chevron-up" />
              </svg>
              <svg
                v-if="!isSortAscending && sortField == 'createdDate'"
                class="icon-chevron-down"
              >
                <use xlink:href="/static/svg-symbols.svg#icon-chevron-down" />
              </svg>
            </th>
            <th
              width="20%"
              scope="col"
            >
              Invite Details
            </th>
            <th
              id="pendingInvitesInviteLink"
              width="30%"
              scope="col"
            >
              Invite Link
            </th>
            <th
              width="10%"
              scope="col"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invite in sortedInvites">
            <td>{{ invite.email }}</td>
            <td>{{ invite.createdDate | date }}</td>
            <td>
              <ul>
                <li v-for="role in invite.roles">
                  <strong>{{ groupIdsToNames[role.groupId] }}:</strong>
                  <span>{{ buildRolesString(role.roles, role.groupId) }}</span>
                </li>
              </ul>
            </td>
            <td>
              <input
                style="width: 300px;"
                type="text"
                aria-labelledby="pendingInvitesInviteLink"
                :value="inviteLinkPrefix + invite.inviteId"
                onfocus="this.select()"
              >
            </td>
            <td>
              <a
                href="#"
                @click.prevent="deleteInvite(invite.inviteId)"
              >
                Delete
              </a> -
              <a
                href="#"
                @click.prevent="resendInvite(invite.inviteId)"
              >
                Resend
              </a>
            </td>
          </tr>
          <tr v-if="!invites.length">
            <td colspan="99">
              <h3 class="text-center">
                No invites
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="less" scoped>
  th a {
    color: white;
    text-decoration: underline;
  }
  th svg {
    fill: white !important;
  }
  .icon-chevron-up, .icon-chevron-down {
    height: 14px; width: 14px;
  }
</style>

<script>
export default {
  props: {
    org: {
      type: Object,
      required: true
    },
    isEdu: {
      type: Boolean,
      default: false
    },
    groups: {
      type: Array,
      required: true
    },
    groupIdsToNames: {},
    invites: {
      required: true
    }
  },
  data() {
    return {
      sortField: 'createdDate',
      isSortAscending: false,
      inviteLinkPrefix: document.location.origin + '/join?invite='
    };
  },
  computed: {
    sortedInvites() {
      return this._.orderBy(this.invites, this.sortField, (this.isSortAscending) ? 'asc' : 'desc');
    },
  },
  methods: {
    formatRoleName(roleValue, groupId) {
      // org-level group
      if (groupId === null) {
        return (roleValue == 'manager') ?
          (this.isEdu) ? 'Can add new classes' : 'Can add new groups' :
          'Full admin access';
      }

      if (roleValue === 'manager') {
        return (this.isEdu) ? 'Instructor' : 'Coach';
      }
      return (this.isEdu) ? 'Student' : 'Speaker';
    },
    buildRolesString(roles, groupId) {
      return this._.map(roles, r => this.formatRoleName(r, groupId)).join(', ');
    },
    resendInvite(inviteId) {
      this.$store.dispatch('editInvite', {inviteId, resendInvite: true}).then(() => {
        this.$store.dispatch('notify', {
          type: 'success',
          subject: 'Invite Sent',
          text: 'The invite has been resent to the associated email address.'
        });
      });
    },
    deleteInvite(inviteId) {
      if (confirm('Are you sure you want to delete this invite?')) {
        this.$store.dispatch('deleteInvite', inviteId);
      }
    },
    resortBy(requestedField) {
      if (this.sortField === requestedField) {
        this.isSortAscending = !this.isSortAscending;
      } else {
        this.sortField = requestedField;
        this.isSortAscending = true;
      }
    }
  }
};
</script>
